import { webflowUrl } from "@app/providers";

export function getDefaultUrl(userInfo?: any) {
  let defaultUrl = "/";
  const userType = userInfo && userInfo.userType;
  if (userType != "student" && (userInfo && !userInfo["ageVerfiedflag"])) {
    localStorage.setItem("paymentSource", "signIn");
    if (userType === "educator") {
      return userInfo["educatorLicenseType"] === "teacherAccount" ? "/payment" : "/educator"
    } else {
      return '/payment';
    }
  }
  if (userType === "student" && userInfo["avatarPreview"] === undefined) {
    defaultUrl = "/profile";
  } else if (userType === "parent") {
    defaultUrl = "/profile";
  } else if (userType === "educator") {
    defaultUrl = "/educator";
  }

  return defaultUrl;
}

export const privacyUrl = webflowUrl + "privacy-policy";

export const termsUrl = webflowUrl + "terms";

export const ambassadorUrl = webflowUrl + "company/kazoobadoo-ambassadors";
